export const filterData = {
  combo: [
    "Combo of 2",
    "Combo of 3",
    "Combo of 4",
    "Combo of 5",
    "Combo of 6",
    "Couples Set",
    "Kurti with Saree",
    "Single",
  ],

  COLOR_OPTIONS: [
    "Aqua Blue",
    "Beige",
    "Black",
    "Blue",
    "Brown",
    "Coral",
    "Cream",
    "Gold",
    "Green",
    "Grey",
    "Grey Melange",
    "Khaki",
    "Lavendar",
    "Lemon Yellow",
    "Maroon",
    "Metallic",
    "Mint Green",
    "Multicolor",
    "Mustard",
    "Navy Blue",
    "Nude",
    "Olive",
    "Orange",
    "Peach",
    "Pink",
    "Purple",
    "Red",
    "Rust",
    "Silver",
    "Teal",
    "White",
    "Yellow",
  ],

  fabric: [
    "Acrylic",
    "Art Silk",
    "Bamboo",
    "Banarasi Silk",
    "Chambray",
    "Chanderi Cotton",
    "Chanderi Silk",
    "Chiffon",
    "Cotton",
    "Cotton Blend",
    "Cotton Cambric",
    "Cotton Linen",
    "Cotton Silk",
    "Cotton Slub",
    "Crepe",
    "Denim",
    "Dupion Silk",
    "Georgette",
    "Jacquard",
    "Jute Cotton",
    "Jute Khadi",
    "Jute Silk",
    "Khadi Cotton",
    "Khadi Silk",
    "Kora Muslin",
    "Lace",
    "Linen",
    "Mulmul",
    "Muslin",
    "Net",
    "Nylon",
    "Organza",
    "Paper Silk",
    "Pashmina",
    "Poly Chiffon",
    "Poly Crepe",
    "Poly Georgette",
    "Poly Silk",
    "Polycotton",
    "Polyester",
    "Polyster",
    "Rayon",
    "Rayon Slub",
    "Satin",
    "Satin Silk",
    "Shantoon",
    "Silk",
    "Silk Blend",
    "Soft Silk",
    "Super Net",
    "Synthetic",
    "Synthetic Crepe",
    "Taffeta Silk",
    "Tissue",
    "Tussar Silk",
    "Velvet",
    "Vichitra Silk",
    "Viscose",
    "Viscose Rayon",
    "Viscose Silk",
    "Voile",
    "Wool",
  ],

  fitShape: [
    "A-line",
    "Alia Cut",
    "Anarkali",
    "Angrakha",
    "Assymetrical",
    "C-Cut",
    "Cowl",
    "Crop Top Kurti",
    "Dhoti",
    "Empire",
    "Flared",
    "Front Slit",
    "Gown",
    "Gujrati",
    "High- Slit",
    "High-Low",
    "Jacket Kurta",
    "Jaipuri",
    "Kaftan",
    "Kashmiri",
    "Layered",
    "Lucknowi",
    "Maternity",
    "Maxi Kurta",
    "Naira Cut",
    "Pakistani",
    "Panelled",
    "Pleated",
    "Rajasthani",
    "Sambalpuri",
    "Short",
    "Short Kurti",
    "Shrug Kurti",
    "Straight",
    "Tiered",
    "Tunic",
  ],

  generic: [
    "Accessories",
    "Bottom Wear",
    "Garment",
    "Kurtis",
    "Others",
    "Sportswear",
    "Topwear",
    "Undergarment",
  ],

  length: ["Above Knee", "Ankle Length", "Calf Length", "Knee length"],

  neck: [
    "Boat",
    "Collar",
    "Court",
    "Cowl",
    "Halter",
    "Horse Shoe",
    "Keyhole",
    "Mandarin",
    "Notch",
    "Off-Shoulder",
    "Paan",
    "Round",
    "Scoop",
    "Shawl",
    "Shirt",
    "Square",
    "Stylised",
    "Surplice",
    "Sweetheart",
    "Tie - Up",
    "V-neck",
  ],

  occasion: ["Daily", "Festive", "Maternity", "Office", "Party", "Wedding"],

  pattern: [
    "Applique",
    "Checked",
    "Chikankari",
    "Colorblocked",
    "Dyed/ Washed",
    "Embellished",
    "Embroidered",
    "Printed",
    "Self-Design",
    "Solid",
    "Striped",
    "Woven Design",
    "Zari Embroidered",
    "Zari Woven",
  ],

  print_pattern: [
    "Abstract",
    "Ajrakh",
    "Animal",
    "Applique",
    "Aztec",
    "Bandhani",
    "Batik",
    "Block",
    "Bohemian",
    "Botanical",
    "Checked",
    "Chevron",
    "Colorblocked",
    "Embellished",
    "Ethnic Motif",
    "Floral",
    "Foil",
    "Geometric",
    "Graphic",
    "Herringbone",
    "Houndstooth",
    "Ikat",
    "Kalamkari",
    "Leheriya",
    "Madhubani",
    "Micro",
    "Paisley",
    "Polka Dot",
    "Quirky",
    "Ribbon",
    "Scenic",
    "Shibori",
    "Solid",
    "Stripe",
    "Tie and Dye",
    "Tribal",
    "Warli",
    "Woven Design",
    "Zari Butta",
  ],

  sleeve_length: [
    "Long Sleeves",
    "Short Sleeves",
    "Sleeveless",
    "Three-Quarter Sleeves",
  ],

  stitch_type: ["Semi-Stitched", "Stitched", "Unstitched"],
  country: [
    "India",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
  ],
};

export const PRODUCT_DETAIL_FIELDS = [
  {
    label: "Color",
    field: "color",
    options: filterData?.COLOR_OPTIONS,
    required: true,
  },
  {
    label: "Combo of",
    field: "comboOf",
    options: filterData?.combo,
    required: true,
  },
  {
    label: "Fabric",
    field: "fabric",
    options: filterData?.fabric,
    required: true,
  },
  {
    label: "Fit/ Shape",
    field: "fitShape",
    options: filterData?.fitShape,
    required: true,
  },
  {
    label: "Generic Name",
    field: "genericName",
    options: filterData?.generic,
    required: true,
  },
  {
    label: "Length",
    field: "length",
    options: filterData?.length,
    required: true,
  },
  {
    label: "Neck",
    field: "neck",
    options: filterData?.neck,
    required: true,
  },
  {
    label: "Occasion",
    field: "occasion",
    options: filterData?.occasion,
    required: true,
  },
  {
    label: "Pattern",
    field: "pattern",
    options: filterData?.pattern,
    required: true,
  },
  {
    label: "Print or Pattern Type",
    field: "printOrPatternType",
    options: filterData?.print_pattern,
    required: true,
  },
  {
    label: "Sleeve Length",
    field: "sleeveLength",
    options: filterData?.sleeve_length,
    required: true,
  },
  {
    label: "Stitch Type",
    field: "stitchType",
    options: filterData?.stitch_type,
    required: true,
  },
  {
    label: "Country Of Origin",
    field: "countryOfOrigin",
    options: filterData?.country,
    required: true,
  },
];

export const SIZE_LIST = [
  "XXS",
  "XS",
  "S",
  "M",
  "L",
  "XL",
  "XXL",
  "XXXL",
  "4XL",
  "5XL",
  "6XL",
  "7XL",
];
